import { render, staticRenderFns } from "./CanvasDesk.vue?vue&type=template&id=62093ca0&scoped=true&"
import script from "./CanvasDesk.vue?vue&type=script&lang=js&"
export * from "./CanvasDesk.vue?vue&type=script&lang=js&"
import style0 from "./CanvasDesk.vue?vue&type=style&index=0&id=62093ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62093ca0",
  null
  
)

export default component.exports